module.exports = __webpack_public_path__ + "5932d5735a51329b5f5d176a0cdd54cc.jpg";